import type {
  VoiceTenantOverview,
  VoiceTenantOverviewListResponse,
  VoiceTenantOverviewSummary,
  VoiceUsageStart,
} from '@reach/shared-types/voice-tenant-overview';
import { partnerApi, type ApiResponse } from '../../../lib/api';
import { API_ENDPOINTS } from '../../../lib/constants';

export type { VoiceTenantOverview, VoiceTenantOverviewSummary };

export type VoiceTenantOverviewsResult = {
  data: VoiceTenantOverview[];
  hasNextPage: boolean;
  cursor?: string;
};

export async function fetchVoiceTenantOverviews(
  options: { cursor?: string; limit?: number } = {},
): Promise<VoiceTenantOverviewsResult> {
  const url = new URL(API_ENDPOINTS.PARTNER.VOICE_TENANTS, window.location.origin);
  if (options.cursor) url.searchParams.set('cursor', options.cursor);
  if (options.limit !== undefined) url.searchParams.set('limit', options.limit.toString());

  const response = await partnerApi.request<ApiResponse<VoiceTenantOverviewListResponse>>(
    url.pathname + url.search,
  );
  const payload = response.data;
  if (!payload) {
    throw new Error('Voice tenant overview response missing data');
  }
  return {
    data: payload.results,
    hasNextPage: payload.pagination.hasNextPage,
    cursor: payload.pagination.cursor ?? undefined,
  };
}

export async function fetchVoiceTenantOverviewSummary(): Promise<VoiceTenantOverviewSummary> {
  const response = await partnerApi.request<ApiResponse<VoiceTenantOverviewSummary>>(
    API_ENDPOINTS.PARTNER.VOICE_TENANTS_SUMMARY,
  );
  const payload = response.data;
  if (!payload) {
    throw new Error('Voice tenant overview summary response missing data');
  }
  return payload;
}

export async function fetchVoiceUsageStart(): Promise<VoiceUsageStart> {
  const response = await partnerApi.request<ApiResponse<VoiceUsageStart>>(
    API_ENDPOINTS.PARTNER.VOICE_USAGE_START,
  );
  const payload = response.data;
  if (!payload) {
    throw new Error('Voice usage start response missing data');
  }
  return payload;
}
